<script setup lang="ts">
defineProps<{ message: string }>();
defineEmits<{ dismiss: [] }>();
</script>

<template>
  <div class="banner" role="alert">
    <span class="dot" aria-hidden="true">!</span>
    <span class="msg">{{ message }}</span>
    <button class="close" type="button" aria-label="Dismiss" @click="$emit('dismiss')">×</button>
  </div>
</template>

<style scoped>
.banner {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  background: #fde7e0;
  color: #6a2515;
  padding: 0.65rem 0.9rem;
  border-radius: 10px;
  border: 1px solid #f4b9a7;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #d3593e;
  color: white;
  font-weight: 700;
  font-size: 0.85rem;
  flex: 0 0 auto;
}
.msg { flex: 1 1 auto; }
.close {
  border: none;
  background: transparent;
  color: #6a2515;
  cursor: pointer;
  font-size: 1.3rem;
  line-height: 1;
  padding: 0 0.25rem;
}
.close:hover { color: #401403; }
</style>
